import { GregorioClefType } from '../../gregorio-chant/enums/GregorioClefType';
import { GregorioElement } from '../../gregorio-chant/structures/GregorioSyllable';
import { ChantContext } from '../../gregorio-chant/ChantContext';
import { Glyph } from '../glyphs/Glyph';
import { GlyphVisualizer } from '../visualizers';
import { ChantLayoutElement } from '../layout/ChantLayoutElement';
import { Space } from '../elements/Space';

export class Clef extends ChantLayoutElement {
  private _element: GregorioElement;
  private _visualizer: GlyphVisualizer;
  private _flatVisualizer?: GlyphVisualizer;
  private _spaceAfter: Space;

  get gabc(): GregorioElement {
    return this._element;
  }

  get top(): number {
    return this._visualizer.top;
  }

  constructor(context: ChantContext, element: GregorioElement) {
    super(context);
    this._element = element;
    const clef = element!.misc.clef;
    console.log(clef);
    const glyphName = clef.clef === GregorioClefType.C ?
      'CClef' : 'FClef';

    this._visualizer = new GlyphVisualizer(context,
      new Glyph(glyphName, context.gabcFont, context.gabcGlyphSize), this._context.gabcColor);

    this._visualizer.setLine(clef.line);
    this._visualizer.bounds.setX(0);

    if (clef.flatted) {
      this._flatVisualizer = new GlyphVisualizer(context,
        new Glyph('Flat', context.gabcFont, context.gabcGlyphSize), this._context.gabcColor);
      this._flatVisualizer.setLine(clef.line);
    }

    this._spaceAfter = new Space(context, this._distanceConverter.lengthToPx(context.spaceafterlineclef));
  }

  public performLayout(args: ChantLayoutElement[]): void {
    this.bounds.setWidth(this._visualizer.bounds.width);

    if (args.length > 1) {
      this._visualizer.bounds.setX(args[args.length - 1].bounds.right);
    }
    this._spaceAfter.bounds.setX(this._visualizer.bounds.right);

    if (this._flatVisualizer) {
      const clefflatspace = this._distanceConverter.lengthToPx(this._context.clefflatspace);
      this._flatVisualizer.bounds.setX(this._visualizer.bounds.right + clefflatspace);
      this._spaceAfter.bounds.setX(this._flatVisualizer.bounds.right);
      this.bounds.setWidth(this._visualizer.bounds.width + this._flatVisualizer.bounds.width);
    }
  }

  copy(): Clef {
    return new Clef(this._context, this._element);
  }

  public createSvgFragments(): SVGElement[] {
    return [
      ...this._visualizer.createSvgFragments(),
      ...(this._flatVisualizer ? this._flatVisualizer.createSvgFragments() : []),
      ...this._spaceAfter.createSvgFragments(),
    ];
  }
}
